import React, { useState, useEffect, useContext } from "react";
import useObtenerGastosDelMes from "./../hooks/useObtenerGastosDelMes";

const TotalGastadoContext = React.createContext();

//hook
const useTotalDelMes = () => useContext(TotalGastadoContext);

const TotalGastadoProvider = ({ children }) => {
  const [total, cambiarTotal] = useState(0);
  //obtenemos un arreglo con los gastos del mes
  const gastos = useObtenerGastosDelMes();

  useEffect(() => {
    //console.log(gastos)
    let acumulado = 0;
    gastos.forEach(gasto => {
      acumulado += gasto.cantidad;
    });
    //console.log(acumulado);
    cambiarTotal(acumulado);
  }, [gastos]);

  return (
    <TotalGastadoContext.Provider value={{ total: total }}>
      {children}
    </TotalGastadoContext.Provider>
  );
};

export { TotalGastadoProvider, useTotalDelMes };
